import { numberToPrettyString } from '@cian/utils';
import { createSelector } from '@reduxjs/toolkit';

import { NBSP } from 'shared/constants/symbols';
import { ELabelColor } from 'shared/types/etazhiBlackFriday';

import { selectEtazhiBlackFridayFullOfferPrice } from './selectEtazhiBlackFridayFullOfferPrice';
import { selectEtazhiBlackFridayPromoOffersData } from './selectEtazhiBlackFridayPromoOffersData';
import { getEtazhiBlackFridayPriceDiscountColors } from './utils/getEtazhiBlackFridayPriceDiscountColors';
import { getIsRSEnabled } from './utils/getIsRSEnabled';
import { selectOfferPriceRub } from '../offerData/offer/selectOfferPriceRub';

export const selectEtazhiBlackFridayOfferDiscount = createSelector(
  selectOfferPriceRub,
  selectEtazhiBlackFridayPromoOffersData,
  selectEtazhiBlackFridayFullOfferPrice,
  (priceRur, promoOffersData, fullPrice) => {
    if (!fullPrice) {
      return null;
    }

    if (!getIsRSEnabled(promoOffersData)) {
      return null;
    }

    const discountPercent = Math.floor(((fullPrice - priceRur) / fullPrice) * 100);

    if (promoOffersData && promoOffersData.minDiscount && discountPercent >= promoOffersData.minDiscount) {
      return {
        percent: `-${discountPercent}%`,
        newPrice: `${numberToPrettyString(priceRur)}${NBSP}₽`,
        oldPrice: `${numberToPrettyString(fullPrice)}${NBSP}₽`,
        colors: getEtazhiBlackFridayPriceDiscountColors(
          /* istanbul ignore next */
          (promoOffersData.desktop?.label?.color as ELabelColor) ?? ELabelColor.DarkGreen,
        ),
      };
    }

    return null;
  },
);
